/* global SWDLocalise */
import lottie from 'lottie-web';

const animationContainer = document.querySelector('.js-ambassadors-animation');

const hero = () => (
    new Promise((resolve) => {
        const animation = lottie.loadAnimation({
            container: animationContainer,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: `${SWDLocalise.mediaUrl}/js/components/ambassadors-hub/animation.json`,
        });

        animation.addEventListener('data_ready', () => {
            animationContainer.classList.remove('is-loading');
            resolve();
        });
    })
);

const init = () => {
    if (!animationContainer) return;
    hero();
};

export default init;
